module.exports = __webpack_public_path__ + "static/media/forex_sport_footer.69e4a137.png";